/** 商机 */
import React from 'react';

import "../css/HomePage.css";
import "../css/BusinessChance.css";

import Cache from "../frame/Cache";
import Config from "../config/Config";
import WidgetAjax from "../widget/WidgetAjax";
import WidgetMessage from '../widget/WidgetMessage';
import BusinessEntity from "./BusinessChanceWidget/BusinessEntity";
import BusinessCatlogs from "./BusinessChanceWidget/BusinessCatlogs"

import LoadingTag from "../img/frame/loading.gif";
import TitleLeft from "../img/BusinessChance/TitleLeft.svg";
import BackToTop from "../img/BusinessChance/backToTop.svg";
import Magnifier from "../img/BusinessChance/Magnifier-1.svg";

class BusinessChance extends React.Component 
{
    constructor(props)
    {
        super(props)
        
        const url = Config.getBasePath()
        this.state={
            url:url,
            basePath:Config.getBasePath(),
            themeData:[],
            catalogData:[],
            userCatalogData:[],
            themeActive:undefined,
            businessSearchInput:"商机主题关键字搜索",
            allCatalog:[],
            pagingOptions:{
                total:0
            },
            messageOptions:{
            },
            isBackToTop:false,
            isOpenSearchTag:false,
            isLoading:true,
            userCatalogLoading:true,
            loading:true,
            businessCatalog:undefined,
            isClickLeft:false,
            catalogLoadingOver:[],
            cataLogDatas:[],
            scrollTopX:0
        };

        this.onTwo = this.onTwo.bind(this)
        this.backTop = this.backTop.bind(this);
        this.floorBody = this.floorBody.bind(this);
        this.loadTheme = this.loadTheme.bind(this);
        this.adsorbBody = this.adsorbBody.bind(this);
        this.searchData = this.searchData.bind(this);
        this.loadCatalog = this.loadCatalog.bind(this);
        this.loadingOver = this.loadingOver.bind(this);
        this.themeSearch = this.themeSearch.bind(this);
        this.onLoadTheme = this.onLoadTheme.bind(this);
        this.loadBusiness = this.loadBusiness.bind(this);
        this.onSearchData = this.onSearchData.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.onLoadCatalog = this.onLoadCatalog.bind(this);
        this.changeCatalog = this.changeCatalog.bind(this);
        this.loadUserCatalog = this.loadUserCatalog.bind(this);
        this.keyWordOnChange = this.keyWordOnChange.bind(this);
        this.themeSearchKeyUp = this.themeSearchKeyUp.bind(this);
        this.onLoadUserCatalog = this.onLoadUserCatalog.bind(this);
        this.changeThemeActive = this.changeThemeActive.bind(this);
        this.changeisClickLeft = this.changeisClickLeft.bind(this);
        this.changeIsOpenSearchTag = this.changeIsOpenSearchTag.bind(this);
        this.businessCatalogEntity = this.businessCatalogEntity.bind(this);
    }

    /**
     * 初始化操作
     */
    componentDidMount()
    {

        let data = this.props.location.state;

        if(data != undefined || data != null)
        {
            this.setState({beforeHomePage:data})
        }

        this.loadTheme();
    }

    messageRef = (ref) => {
        this.messageRef = ref;
    }

    drawerRef = (ref) => {
        this.drawerRef = ref;
    }

    /**
     * 请求商机主题清单（左侧）
     */
    loadTheme()
    {
        let { basePath } = this.state

        WidgetAjax.ajax({url: basePath + "/business/theme", params: {page:1, records:999} , callback: this.onLoadTheme});
        this.setState({ loading: true });
    }

    onLoadTheme( result )
    {   
        let { themeActive } = this.state;
        
        if( result.status===0 )
        {
            let newCatalog = [];
            
            if( themeActive===undefined || themeActive===null || themeActive==="" )
            {
                themeActive = result.results[0].THMCODE;
            }

            result.results.map((val,index) => {
                newCatalog.push({"THMCODE":val.THMCODE,"NAME":val.NAME})
            });
            

            this.setState({
                themeData:result.results, 
                allThemeData:result.results, 
                themeActive:themeActive, 
                allCatalog:newCatalog, 
                loading:false
            });

            this.loadBusiness();
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

     loadBusiness()
    {
        
        this.setState({userCatalogData:[]});

        this.loadUserCatalog();     
    }

    /**
     * 请求用户关注的商机目录
     */
    loadUserCatalog(before = undefined)
    {
        let { basePath } = this.state;

        if(before === "beforeWidget")
        {
            this.setState({userCatalogData:[]})
        }

        let params = {
            "type" : 2,
            "page" : 1,
            "records" : 9999,
        };

        WidgetAjax.ajax({url: basePath + "/business/catalog", params: params , callback: this.onLoadUserCatalog});
    }

    onLoadUserCatalog( result )
    {
        if( result.status===0 ) 
        {
            let newData = this.state.userCatalogData;

            if( result.results===[] )
            {
                return null;
            }

            result.results.forEach((val, index) => {
                newData.push(val)
            });

            this.setState({userCatalogData:newData,userCatalogLoading:false},()=>{
                this.loadingOver(true)
            });
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        } 
    }

    /**
     * 商机主题回车按钮
     * @param {*} e 
     */
    themeSearchKeyUp( e )
    {
        if( e.keyCode===13 )
        {
            this.themeSearch(e);
        }
    }
    
    /**
     * 商机主题搜索
     * @param {*} e 
     */
    themeSearch( e )
    {
        let { allThemeData,allCatalog } = this.state;

        let themeData = [];
        
        if( e.target.value!="" )
        {
            for(let item of allThemeData )
            {
                if( item.NAME.indexOf(e.target.value)!==-1 )
                {
                    themeData.push(item);
                }
            }
        }
        else
        {
            allCatalog.forEach((i,ind)=>{
                if(document.getElementById(i.THMCODE + "_id")){
                    if(document.getElementById("T001_id")){
                        document.getElementById("T001_id").className = "leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive";
                    }
                    document.getElementById(i.THMCODE + "_id").className = "leftList lineheight-50 cursor-pointer paddingLeft-44 borderbottom-F8FBFF font-14 font-PingFangFCRegular";
                }
            })
            themeData.push(...allThemeData);
        }

        this.setState({themeData:themeData});
    }

    /**
     * 商机主题Tabs
     * @param {*} params 
     */
    changebusinessThemeListActive( e, params, item)
    {
        // console.log(item)
        
        let { allCatalog } = this.state
        let id = params==="beforeHomePage"? e.id.split("_")[0]: e.currentTarget.id.split("_")[0];
        let ele = document.getElementById(id);
            this.setState({isOpenSearchTag:false,isClickLeft:true},()=>{
                ele.scrollIntoView({behavior:'smooth'}); 
                allCatalog.forEach((i,ind)=>{
                    if(document.getElementById(i.THMCODE + "_id")){
                        document.getElementById(i.THMCODE + "_id").className = "leftList lineheight-50 cursor-pointer paddingLeft-44 borderbottom-F8FBFF font-14 font-PingFangFCRegular";
                    }
                })
                    document.getElementById(id + "_id").className = "leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive";
            });
        
    }

    changeIsOpenSearchTag(bool)
    {
        this.setState({
            isOpenSearchTag: bool,
        })
        document.getElementById("businessChance-body").scrollTop = 0;
    }

    /**
     * 当主题搜索框获得焦点时
     */
    clearInput()
    {
        this.setState({ businessSearchInput : ""});
    }

    /**
     * 当商机主题搜索框失去焦点时
     */
    recoverInput(e)
    {
        if(e.target.value==="")
        {
            this.setState({businessSearchInput:"商机主题关键字搜索" });
        }
    }

    /**
     * 改变商机主题的状态
     * @param {*} param 
     */
    changeCatalog(item)
    {
        this.setState({
            catalogActive : item.CTGCODE
        });

        this.searchData(1);
    }

    /**
     * 关键字输入框变化函数
     * @param value 
     */
    keyWordOnChange( value )
    {
        this.setState({
            keyWord:value
        });
    }

    /**
     * 关键字回车事件
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        if( e.keyCode===13 ) 
        {
            this.searchData(1);
        }
    }  

    searchData( page )
    {
        const { catalogActive, keyWord, options, basePath} = this.state;

        if( !catalogActive ) return ;
        
        let { schema } = this.state, filters = {};
        
        if( page===undefined )
        {
            page = 1;
        }

        if( keyWord!==undefined &&  keyWord!==null && keyWord!=="" )
        {
            filters["ENTNAME"] = "${ENTNAME} has '"+keyWord+"'";
        }
       
        if( catalogActive!==undefined && catalogActive!==null )
        {
            schema += "_" + catalogActive;
        }

        let params = {
            page : page,
            records : options.records,
            schema : schema,
            filters :filters,
        };

        WidgetAjax.ajax({url:basePath + '/report/data', params:params, callback:this.onSearchData});

    }

    onSearchData( result )
    {
        if( result.status===0 )
        {
            let {  keyWord, options } = this.state;

            options["keyWord"] = keyWord;

            this.setState({data:result.results, total:result.total, options:options, loading:false});
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 左侧列表吸附效果
     */
    adsorbBody(e)
    {
        let { themeData,scrollTopX } = this.state
        let arr=document.getElementById("T014_id")
        let add=document.getElementById("T012_id")
        let T013_id = document.getElementById("T013_id")

        if( e.target.id==="businessChance-body" )
        {
            let scrollTopX = e.target.scrollTop;
            document.getElementById("businessChance-left").style.top = scrollTopX+"px";

            this.floorBody(scrollTopX);
             
            if(scrollTopX>600)
            {
                if(this.state.isBackToTop != true)
                {
                    this.setState({
                        isBackToTop:true,
                    });
                }
            }
            else
            {
                if(this.state.isBackToTop != false)
                {
                    this.setState({
                        isBackToTop:false
                    });
                }
            }
            if(scrollTopX >= 4099){
                if(add) add.className="leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular"
                if(arr) arr.className="leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive"
                if(T013_id) T013_id.className = "leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular"
            }
            
        }
    }

    changeisClickLeft()
    {
        let {isClickLeft} = this.state;
        if(isClickLeft)
        {
            this.setState({
                isClickLeft:false
            });
        }
    }

    floorBody(scrollTopX)
    {
        let {allCatalog, isOpenSearchTag, isClickLeft} = this.state;
        if(isClickLeft === false)
        {
            if(!isOpenSearchTag)
            {
                allCatalog.forEach((val,index)=>{

                    let elementTop = document.getElementById(val.THMCODE+"_title");

                    if(scrollTopX+100 > elementTop.offsetTop && scrollTopX-10 < elementTop.offsetTop+elementTop.clientHeight){

                        allCatalog.forEach((item,ind)=>{
                            if(document.getElementById(item.THMCODE + "_id")){
                                document.getElementById(item.THMCODE + "_id").className = "leftList lineheight-50 cursor-pointer paddingLeft-44 borderbottom-F8FBFF font-14 font-PingFangFCRegular";
                            }
                        })

                        if(document.getElementById(val.THMCODE + "_id")) document.getElementById(val.THMCODE + "_id").className = "leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive"
                    }
                })
            }
        }
        
    }

    changeThemeActive(THEMECODE)
    {
        let {allCatalog} = this.state
        allCatalog.forEach((item,ind)=>{
            document.getElementById(item.THMCODE + "_id").className = "leftList lineheight-50 cursor-pointer paddingLeft-44 borderbottom-F8FBFF font-14 font-PingFangFCRegular ";
        })
        document.getElementById(THEMECODE + "_id").className = "leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive";
    }

    /**
     * 跳转高级搜索
     */
     businessCatalogEntity( item, val )
     {
        if(val != undefined || val != null)
        {
            this.changeThemeActive(val.THMCODE);
        }
        this.changeIsOpenSearchTag(true);
        this.setState({businessCatalog:item});
     }
    
    /**
     * 路由跳转
     */
    routeJumpToThis()
    {
        let THMCODE = this.props.location.state.data.THMCODE;
        this.setState({
            themeActive:THMCODE?THMCODE:""
        });
    }

    /**
     * 返回顶部
     */
    backTop()
    {
        let { themeData } = this.state;
        let ele = document.getElementById("BusinessChanceCatlog");
        ele.scrollIntoView({behavior:'smooth'}); 
        
        this.setState({themeActive:themeData[0].THMCODE,isClickLeft:false});
    }

    /**
     * 商机目录加载
     * @param {*} params 
     */
    loadingOver(params)
    {
        if(this.state.beforeHomePage)
        {
            let {catalogLoadingOver,themeData,beforeHomePage} = this.state,
                {data,type} = beforeHomePage;
            
            catalogLoadingOver.push(params);
            this.setState({catalogLoadingOver})
            if(catalogLoadingOver.length === themeData.length + 1)
            {
                if(type==="THEME")
                {
                    let ele = document.getElementById(data.THMCODE + "_id");
                    this.changebusinessThemeListActive(ele,"beforeHomePage");
                }
                else if(type === "CATALOG")
                {
                    this.loadCatalog(data.THMCODE);
                }
            }
        }
    }

    /**
     * 请求商机目录
     */
    loadCatalog( THMCODE )
    {
        let { basePath, records, pageIndex } = this.state;

        let params = {
            "type" : 1,
            "page" : pageIndex,
            "records" : records,
            "THMCODE":THMCODE
        };

        WidgetAjax.ajax({url: basePath + "/business/catalog", params: params , callback: this.onLoadCatalog});
    }

    onLoadCatalog( result, backParam )
    {
        if( result.status===0 ) 
        {
            let { results } = result;
            let {data} = this.state.beforeHomePage,cataLogDatas;
            let val = {THMCODE:data.THMCODE,NAME:data.CTGNAME};

            results.forEach((item,index)=>{
                if(item.CTGCODE === data.CTGCODE)
                {
                    cataLogDatas = item
                }
            })
            
            this.businessCatalogEntity(cataLogDatas, val);
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    onTwo(none)
    {
        this.setState({isOpenSearchTag:none})
    }

    render() 
    {
        let { themeData, businessSearchInput, allCatalog, userCatalogData, messageOptions, isBackToTop, 
                isOpenSearchTag, loading, businessCatalog, userCatalogLoading } = this.state;

        return (
            <div id="businessChance-body" className="businessChance-body display-flex overflow-auto" onWheel={this.changeisClickLeft} onScroll={loading?null:(e)=>{this.adsorbBody(e)}} ref="scroll">
                <div id="businessChance-left" className="businessChance-left background-fff radius-5 overflow-hidden isSuctionTop-left">
                    {
                        loading ? <img src={LoadingTag} className='loadingTags-style'/> :
                        <div className="businessChance-content">
                            <div className="leftListSearch borderbottom-F8FBFF">
                                <input  placeholder={businessSearchInput} 
                                        onFocus={()=>{this.clearInput()}} 
                                        onBlur={(e)=>{this.recoverInput(e)}}
                                        onKeyUp={ this.themeSearchKeyUp }
                                        onChange={(e)=> { this.themeSearch(e)}}
                                        className="themeSearchInput font-PingFangFC" 
                                />
                                <img src={Magnifier} className={businessSearchInput? "Magnifier-1" : "display-none"}/>
                            </div>
                            {
                                themeData.map((item,index) => {
                                    return (
                                        <div onClick={(e)=>{this.changebusinessThemeListActive(e,index,item)}}
                                            key={item.THMCODE}
                                            id={`${item.THMCODE}_id`}
                                            className={index===0?
                                                "leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive":
                                                "leftList lineheight-50 cursor-pointer paddingLeft-44 borderbottom-F8FBFF font-14 font-PingFangFCRegular"
                                            }
                                        >
                                            {item.NAME}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                </div>

                <div id="BusinessChanceCatlog" className={ isOpenSearchTag ? "flex-8 marginleft-16 radius-5":"background-fff flex-8 marginleft-16 radius-5"} style={{height:'100%', display:'table', width: 'calc(100% - 220px)'}}>
                    
                    <div style={isOpenSearchTag ? {}: {display:"none"}}>
                        <BusinessEntity parentProps={this.props} theme={this.props.themeData} item={businessCatalog} isOpenSearchTag={isOpenSearchTag} onTwo = {this.onTwo}></BusinessEntity>
                    </div>
                    {
                        <div style={isOpenSearchTag ? {display:"none"} : {}}>
                            <div className="businessSubscription" id="myStar">
                                {    
                                    userCatalogLoading ?
                                    <div style={{height:"200px",width:"100%",paddingLeft:"16px"}}><img src={LoadingTag} className='loadingTags-style'/></div> :
                                    
                                    <div>
                                        <div className="titleContent" style={{paddingTop:"20px"}}>
                                            <img src={TitleLeft} className='leftBorder'/>
                                            <span className="titleText paddingTop-19 paddingleft-9 font-16 fontWeight-600 font-PingFangSCSemibold">企业商机订阅</span>
                                        </div>
                                        <div className="tagsContent" style={{position:"relative"}}>
                                                {   
                                                    userCatalogData.length === 0 ? 
                                                        <div style={{height:"200px",width:"100%"}}>
                                                            <img src={require('../css/widget/img/no-data.svg')} className='No-data-logo'></img>
                                                        </div> :
                                                        userCatalogData.map((val,index)=>{
                                                            return (
                                                                <div className="businessTags font-12 radius-3 click font-12" 
                                                                    onClick={() => {this.businessCatalogEntity(val, undefined)}}
                                                                    key={index}
                                                                >
                                                                    {val.NAME}
                                                                </div>
                                                            )
                                                        })
                                                }
                                        </div>
                                    </div>
                                }
                                
                            </div>
                            {
                                allCatalog.map((val,index)=>{
                                    return (
                                        <div className="businessCatalogContent" id={val.THMCODE} key={index+'businessCatalogContent'} ref="names">
                                            <div className="titleContent paddingleft-10">
                                                <img src={TitleLeft} className='leftBorder'></img>
                                                <span className="titleText paddingleft-9 font-16 fontWeight-600 font-PingFangSCSemibold"id={val.THMCODE+"_title"} >{val.NAME}</span>
                                            </div>
                                            <BusinessCatlogs loadUserCatalog = {this.loadUserCatalog} businessCatalogEntity = {this.businessCatalogEntity} catlogs = {val} loadingOver={this.loadingOver} />
                                        </div>
                                    )
                                })
                            }
                            
                        </div>
                    }
                </div>
                    {/* 回到顶部按钮 */}
                    <div className={isBackToTop ? "backTop" : "display-none"}
                        onClick = {()=>{this.backTop()}}>
                        <img className="backTopImg" src={BackToTop} />
                    </div>

                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
            </div>
        )
    }
}


export default BusinessChance